<template>
    <div class="bussiness_block my-0 py-4">
        <div class="card shadow border-0">
            <div class="row my-4 px-3 px-md-5 align-items-center justify-content-center">
                <div class="col-12">
                    <h1 class="card-title text-center">
                        Zásady zpracování osobních údajů
                    </h1>
                </div>
            </div>
            <div class="card-body px-3 px-md-5">
                <GDPR__1_0 />
            </div>
        </div>
    </div>
</template>

<script>
import GDPR__1_0 from "@/components/GDPRHistory/GDPR__1_0.vue";
export default {
    components: {
        GDPR__1_0
    }
};
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.bussiness_block {
    font-family: 'Arial', sans-serif;
    width: 95%;
    margin: 15px auto;
}

.card {
    border-radius: $radius-lg;
    min-height: 100vh;
}

.card-title {
    font-size: clamp(24px, 4vw, 38px);
}

.list-group-item {
    border: 0;
    padding: 0.75rem 1.25rem;
}
</style>
